import { css } from './lit-base.js';

export const listadoIconos = css`
  .icAdd::before {
    content: "\\ea01";
  }
  
  .ic24horas::before {
    content: "\\ea03";
  }
  
  .ic360::before {
    content: "\\ea04";
  }
  
  .icAcademy::before {
    content: "\\ea02";
  }
  
  .icAccesoDirecto::before {
    content: "\\ea05";
  }
  
  .icAccess::before {
    content: "\\ea06";
  }
  
  .icAcciones::before {
    content: "\\ea08";
  }
  
  .icACM::before {
    content: "\\ea07";
  }
  
  .icAddLogo::before {
    content: "\\ea0b";
  }
  
  .icAddress::before {
    content: "\\ea0a";
  }
  
  .icAdjunto::before {
    content: "\\ea09";
  }
  
  .icAdvancedPanel::before {
    content: "\\ea0c";
  }
  
  .icAgendaM::before {
    content: "\\ea0d";
  }
  
  .icAllSalesman::before {
    content: "\\ea0f";
  }
  
  .icAmueblado::before {
    content: "\\ea0e";
  }
  
  .icApple::before {
    content: "\\ea10";
  }
  
  .icArchivar::before {
    content: "\\ea11";
  }
  
  .icAreas::before {
    content: "\\ea12";
  }
  
  .icArrowDown::before {
    content: "\\ea13";
  }
  
  .icArrowLeft::before {
    content: "\\ea14";
  }
  
  .icArrowLeftTop::before {
    content: "\\ea15";
  }
  
  .icArrowRight::before {
    content: "\\ea16";
  }
  
  .icArrowRightTop::before {
    content: "\\ea17";
  }
  
  .icAscensor::before {
    content: "\\ea18";
  }
  
  .icAsistenciaRemota::before {
    content: "\\ea19";
  }
  
  .icAtras::before {
    content: "\\ea1a";
  }
  
  .icAuto::before {
    content: "\\ea1b";
  }
  
  .icAutoetiqueta::before {
    content: "\\ea20";
  }
  
  .icAvisoImportante::before {
    content: "\\ea1e";
  }
  
  .icAyuda::before {
    content: "\\ea1c";
  }
  
  .icBathrooms::before {
    content: "\\ea21";
  }
  
  .icBestPhoto::before {
    content: "\\ea1d";
  }
  
  .icBetaInmovilla::before {
    content: "\\ea1f";
  }
  
  .icBorrador::before {
    content: "\\ea24";
  }
  
  .icBroke::before {
    content: "\\ea22";
  }
  
  .icBrujula::before {
    content: "\\ea23";
  }
  
  .icCalculadora::before {
    content: "\\ea25";
  }
  
  .icCalendar::before {
    content: "\\ea26";
  }
  
  .icCama::before {
    content: "\\ea29";
  }
  
  .icCamera::before {
    content: "\\ea27";
  }
  
  .icCandado::before {
    content: "\\ea28";
  }
  
  .icCandadoClose::before {
    content: "\\ea2b";
  }
  
  .icCandadoOpen::before {
    content: "\\ea2a";
  }
  
  .icCargar::before {
    content: "\\ea2c";
  }
  
  .icCarpeta::before {
    content: "\\ea2d";
  }
  
  .icCarrito::before {
    content: "\\ea2e";
  }
  
  .icCatastro::before {
    content: "\\ea2f";
  }
  
  .icCertificate::before {
    content: "\\ea30";
  }
  
  .icCirculos::before {
    content: "\\ea31";
  }
  
  .icClose::before {
    content: "\\ea32";
  }
  
  .icCloseSimple::before {
    content: "\\ea33";
  }
  
  .icCollaboration::before {
    content: "\\ea34";
  }
  
  .icCollapseM::before {
    content: "\\ea35";
  }
  
  .icComentarios::before {
    content: "\\ea36";
  }
  
  .icCompartir::before {
    content: "\\ea37";
  }
  
  .icCompartirProp::before {
    content: "\\ea38";
  }
  
  .icConexion::before {
    content: "\\ea3a";
  }
  
  .icConferenciaSolicitar::before {
    content: "\\ea39";
  }
  
  .icConferenciaSolicitarBola::before {
    content: "\\ea3b";
  }
  
  .icContactoCorreoExterno::before {
    content: "\\ea3c";
  }
  
  .icContraer::before {
    content: "\\ea3d";
  }
  
  .icContraerMvl::before {
    content: "\\ea3f";
  }
  
  .icConversorOff::before {
    content: "\\ea40";
  }
  
  .icCopiar::before {
    content: "\\ea3e";
  }
  
  .icCopiarColaboradores::before {
    content: "\\ea41";
  }
  
  .icCorreoELlamada::before {
    content: "\\ea42";
  }
  
  .icCorreoM::before {
    content: "\\ea43";
  }
  
  .icCruces::before {
    content: "\\ea44";
  }
  
  .icCuentagotas::before {
    content: "\\ea45";
  }
  
  .icCursos::before {
    content: "\\ea47";
  }
  
  .icDashared::before {
    content: "\\ea46";
  }
  
  .icDashboard::before {
    content: "\\ea48";
  }
  
  .icDefaultSeguimientos::before {
    content: "\\ea49";
  }
  
  .icDeGrupo::before {
    content: "\\ea4b";
  }
  
  .icDemandasM::before {
    content: "\\ea4a";
  }
  
  .icDescargar::before {
    content: "\\ea4c";
  }
  
  .icDestacado::before {
    content: "\\ea4d";
  }
  
  .icDobleChek::before {
    content: "\\ea4e";
  }
  
  .icDocumentos::before {
    content: "\\ea52";
  }
  
  .icDolar::before {
    content: "\\ea4f";
  }
  
  .icDown::before {
    content: "\\ea50";
  }
  
  .icDucha::before {
    content: "\\ea51";
  }
  
  .icEditar::before {
    content: "\\ea53";
  }
  
  .icEmail::before {
    content: "\\ea54";
  }
  
  .icEmailAbierto::before {
    content: "\\ea55";
  }
  
  .icEmailR::before {
    content: "\\ea56";
  }
  
  .icEmailSent::before {
    content: "\\ea57";
  }
  
  .icEmpresas::before {
    content: "\\ea58";
  }
  
  .icEnProceso::before {
    content: "\\ea59";
  }
  
  .icEnviado::before {
    content: "\\ea5a";
  }
  
  .icEstrella::before {
    content: "\\ea5b";
  }
  
  .icEtiquetaMail::before {
    content: "\\ea5c";
  }
  
  .icExpand::before {
    content: "\\ea5d";
  }
  
  .icExpandM::before {
    content: "\\ea5e";
  }
  
  .icFacebookR::before {
    content: "\\ea5f";
  }
  
  .icFacturas::before {
    content: "\\ea60";
  }
  
  .icFeatured::before {
    content: "\\ea61";
  }
  
  .icFeaturedW::before {
    content: "\\ea62";
  }
  
  .icFiltro::before {
    content: "\\ea63";
  }
  
  .icFirma::before {
    content: "\\ea64";
  }
  
  .icForward::before {
    content: "\\ea65";
  }
  
  .icFoto::before {
    content: "\\ea66";
  }
  
  .icGarage::before {
    content: "\\ea67";
  }
  
  .icGoogle::before {
    content: "\\ea68";
  }
  
  .icGraphics::before {
    content: "\\ea69";
  }
  
  .icGroupUngroup::before {
    content: "\\ea6a";
  }
  
  .icGStreet::before {
    content: "\\ea6b";
  }
  
  .icGuardar::before {
    content: "\\ea6c";
  }
  
  .icHashtag::before {
    content: "\\ea6f";
  }
  
  .icHeart::before {
    content: "\\ea6d";
  }
  
  .icHeartEmpty::before {
    content: "\\ea6e";
  }
  
  .icHelp::before {
    content: "\\ea70";
  }
  
  .icHerramientas::before {
    content: "\\ea71";
  }
  
  .icHide::before {
    content: "\\ea72";
  }
  
  .icHocelot::before {
    content: "\\ea77";
  }
  
  .icHorarios::before {
    content: "\\ea73";
  }
  
  .icIdealista::before {
    content: "\\ea76";
  }
  
  .icImpresora::before {
    content: "\\ea74";
  }
  
  .icInformacion::before {
    content: "\\ea75";
  }
  
  .icInformacionTooltip::before {
    content: "\\ea78";
  }
  
  .icIngresos::before {
    content: "\\ea79";
  }
  
  .icInmovilla::before {
    content: "\\ea7a";
  }
  
  .icInstagramR::before {
    content: "\\ea7b";
  }
  
  .icKpis::before {
    content: "\\ea7c";
  }
  
  .icLayers::before {
    content: "\\ea7d";
  }
  
  .icLike::before {
    content: "\\ea7e";
  }
  
  .icLinkedinR::before {
    content: "\\ea7f";
  }
  
  .icLocation::before {
    content: "\\ea80";
  }
  
  .icLogout::before {
    content: "\\ea81";
  }
  
  .icLoquiero::before {
    content: "\\ea82";
  }
  
  .icMap::before {
    content: "\\ea83";
  }
  
  .icMapaCalor::before {
    content: "\\ea84";
  }
  
  .icMarketplace::before {
    content: "\\ea85";
  }
  
  .icMas::before {
    content: "\\ea86";
  }
  
  .icMaximizar::before {
    content: "\\ea88";
  }
  
  .icMegustaria::before {
    content: "\\ea89";
  }
  
  .icMejor::before {
    content: "\\ea87";
  }
  
  .icMenos::before {
    content: "\\ea8a";
  }
  
  .icMenuHamburguesa::before {
    content: "\\ea8b";
  }
  
  .icMenuPuntos::before {
    content: "\\ea8c";
  }
  
  .icTrespuntos::before {
    content: "\\ea8d";
  }
  
  .icMetricool::before {
    content: "\\ea8e";
  }
  
  .icMicrofono::before {
    content: "\\ea8f";
  }
  
  .icMicroMute::before {
    content: "\\ea90";
  }
  
  .icMinimizar::before {
    content: "\\ea91";
  }
  
  .icMLSMenu::before {
    content: "\\ea92";
  }
  
  .icMoneda::before {
    content: "\\ea93";
  }
  
  .icMover::before {
    content: "\\ea94";
  }
  
  .icMoverA::before {
    content: "\\ea96";
  }
  
  .icMundo::before {
    content: "\\ea95";
  }
  
  .icMusic::before {
    content: "\\ea97";
  }
  
  .icMute::before {
    content: "\\ea98";
  }
  
  .icNeutral::before {
    content: "\\ea99";
  }
  
  .icNewCarpeta::before {
    content: "\\ea9a";
  }
  
  .icNoloquiero::before {
    content: "\\ea9b";
  }
  
  .icNomegustaria::before {
    content: "\\ea9c";
  }
  
  .icNotifications::before {
    content: "\\ea9e";
  }
  
  .icNotRead::before {
    content: "\\ea9d";
  }
  
  .icNovedades::before {
    content: "\\eaa0";
  }
  
  .icObranuevaM::before {
    content: "\\ea9f";
  }
  
  .icOficina::before {
    content: "\\eaa1";
  }
  
  .icOk::before {
    content: "\\eaa4";
  }
  
  .icOpenNewWindow::before {
    content: "\\eaa2";
  }
  
  .icOrdenar::before {
    content: "\\eaa3";
  }
  
  .icPaletaColor::before {
    content: "\\eaa5";
  }
  
  .icPanel::before {
    content: "\\eaa7";
  }
  
  .icPanelAvanzado::before {
    content: "\\eaa6";
  }
  
  .icPanelContable::before {
    content: "\\eaa8";
  }
  
  .icPanelMandos::before {
    content: "\\eaa9";
  }
  
  .icPanoramic::before {
    content: "\\eaaa";
  }
  
  .icParcela::before {
    content: "\\eaab";
  }
  
  .icPause::before {
    content: "\\eaad";
  }
  
  .icPdf::before {
    content: "\\eaac";
  }
  
  .icPending::before {
    content: "\\eaae";
  }
  
  .icPerson::before {
    content: "\\eaaf";
  }
  
  .icPhone::before {
    content: "\\eab0";
  }
  
  .icPhotoChange::before {
    content: "\\eab2";
  }
  
  .icPhotoEditing::before {
    content: "\\eab1";
  }
  
  .icPin::before {
    content: "\\eab3";
  }
  
  .icPinterestR::before {
    content: "\\eab4";
  }
  
  .icPiscina::before {
    content: "\\eab5";
  }
  
  .icPiso::before {
    content: "\\eab6";
  }
  
  .icPlano::before {
    content: "\\eab7";
  }
  
  .icPlay::before {
    content: "\\eab8";
  }
  
  .icPortalesM::before {
    content: "\\eaba";
  }
  
  .icPpt::before {
    content: "\\eab9";
  }
  
  .icPreview::before {
    content: "\\eabb";
  }
  
  .icPrivacidad::before {
    content: "\\eabc";
  }
  
  .icPrivate::before {
    content: "\\eabd";
  }
  
  .icProhipotecas::before {
    content: "\\eabe";
  }
  
  .icPropenviadasM::before {
    content: "\\eabf";
  }
  
  .icProperty::before {
    content: "\\eac0";
  }
  
  .icProspectos::before {
    content: "\\eac1";
  }
  
  .icProtege::before {
    content: "\\eac2";
  }
  
  .icPulseAsset::before {
    content: "\\eac3";
  }
  
  .icQlip::before {
    content: "\\eac4";
  }
  
  .icQLSM::before {
    content: "\\eac5";
  }
  
  .icQR::before {
    content: "\\eac6";
  }
  
  .icRecibidos::before {
    content: "\\eac7";
  }
  
  .icRecursos::before {
    content: "\\eac8";
  }
  
  .icRegiones::before {
    content: "\\eac9";
  }
  
  .icReloj::before {
    content: "\\eaca";
  }
  
  .icRemember::before {
    content: "\\eacb";
  }
  
  .icRememberClicked::before {
    content: "\\eacc";
  }
  
  .icRememberClosed::before {
    content: "\\eacd";
  }
  
  .icRemoveLogo::before {
    content: "\\eace";
  }
  
  .icRemoveUser::before {
    content: "\\eacf";
  }
  
  .icResponder::before {
    content: "\\ead0";
  }
  
  .icResponderTodos::before {
    content: "\\ead1";
  }
  
  .icRestart::before {
    content: "\\ead2";
  }
  
  .icRewind::before {
    content: "\\ead4";
  }
  
  .icSalavideo::before {
    content: "\\ead3";
  }
  
  .icSalir::before {
    content: "\\ead5";
  }
  
  .icSearch::before {
    content: "\\ead6";
  }
  
  .icSelectedColor::before {
    content: "\\ead7";
  }
  
  .icServicios::before {
    content: "\\ead8";
  }
  
  .icServiciosExternos::before {
    content: "\\ead9";
  }
  
  .icServihabitat::before {
    content: "\\eadc";
  }
  
  .icSetting::before {
    content: "\\eada";
  }
  
  .icShortcuts::before {
    content: "\\eade";
  }
  
  .icSink::before {
    content: "\\eadb";
  }
  
  .icSmartBio::before {
    content: "\\eae0";
  }
  
  .icSquare::before {
    content: "\\eadd";
  }
  
  .icStarFill::before {
    content: "\\eadf";
  }
  
  .icStop::before {
    content: "\\eae1";
  }
  
  .icSubirArchivos::before {
    content: "\\eae2";
  }
  
  .icSugerencias::before {
    content: "\\eae3";
  }
  
  .icSuggestion::before {
    content: "\\eae4";
  }
  
  .icTablaFlechas::before {
    content: "\\eae5";
  }
  
  .icTablaMover::before {
    content: "\\eae6";
  }
  
  .icTablas::before {
    content: "\\eae9";
  }
  
  .icTareas::before {
    content: "\\eae8";
  }
  
  .icTareasPendientes::before {
    content: "\\eae7";
  }
  
  .icTelegramR::before {
    content: "\\eaea";
  }
  
  .icTerraza::before {
    content: "\\eaec";
  }
  
  .icThumbnails::before {
    content: "\\eaeb";
  }
  
  .icTitulos::before {
    content: "\\eaed";
  }
  
  .icTop::before {
    content: "\\eaee";
  }
  
  .icTopArrow::before {
    content: "\\eaef";
  }
  
  .icTour::before {
    content: "\\eaf0";
  }
  
  .icTrash::before {
    content: "\\eaf1";
  }
  
  .icTriangle::before {
    content: "\\eaf2";
  }
  
  .icTwitterR::before {
    content: "\\eaf3";
  }
  
  .icUp::before {
    content: "\\eaf4";
  }
  
  .icUpload::before {
    content: "\\eaf5";
  }
  
  .icUrl::before {
    content: "\\eaf7";
  }
  
  .icUrlAlt::before {
    content: "\\eaf6";
  }
  
  .icUser::before {
    content: "\\eaf8";
  }
  
  .icUsers::before {
    content: "\\eaf9";
  }
  
  .icValidar::before {
    content: "\\eafa";
  }
  
  .icValPer::before {
    content: "\\eafb";
  }
  
  .icValPunt::before {
    content: "\\eafc";
  }
  
  .icVideo::before {
    content: "\\eafd";
  }
  
  .icVideoOff::before {
    content: "\\eafe";
  }
  
  .icVoltear::before {
    content: "\\eaff";
  }
  
  .icVolver::before {
    content: "\\eb00";
  }
  
  .icWarning::before {
    content: "\\eb01";
  }
  
  .icWeb::before {
    content: "\\eb02";
  }
  
  .icWhatsapp::before {
    content: "\\eb03";
  }
  
  .icWidgets::before {
    content: "\\eb04";
  }
  
  .icWindows::before {
    content: "\\eb05";
  }
  
  .icWorkflow::before {
    content: "\\eb06";
  }
  
  .icXls::before {
    content: "\\eb07";
  }
  
  .icYoutube::before {
    content: "\\eb08";
  }
  
  .icZona::before {
    content: "\\eb0a";
  }
  
  .icZoneIn::before {
    content: "\\eb09";
  }
  
  .icZoomIn::before {
    content: "\\eb0c";
  }
  
  .icZoomOut::before {
    content: "\\eb0b";
  }
  
  .icKey::before {
    content: "\\eb0d";
  }
  
  .icInsertLogo::before {
    content: "\\eb0e";
  }
  
  .icCheckBlack::before {
    content: "\\eb0f";
  }
  
  .icCloseBlack::before {
    content: "\\eb10";
  }
  
  .icDefault::before {
    content: "\\eb11";
  }
  
  .icEnbudo::before {
    content: "\\eb12";
  }
  
  .icMensajeAgencia::before {
    content: "\\eb13";
  }
  
  .icCorreoLlamada::before {
    content: "\\eb14";
  }
  
  .icStatusColorize::before {
    content: "\\eb15";
  }
  
  .icTiktok::before {
    content: "\\eb17";
  }
  
  .icPhoneClock::before {
    content: "\\eb16";
  }
  
  .icApivirtual::before {
    content: "\\eb19";
  }
  
  .icHistory::before {
    content: "\\eb18";
  }
`
